module.exports = __webpack_public_path__ + "static/media/gearbox_boderlands_seattle_22.7a00db4b.png";